const texts = {
  actions: {
    undoState: {
      tooltip: {
        notes: 'Tooltip for zoom out button',
        message: 'Zoom out',
      },
    },
  },
};

export default texts;
